import { GlobeAltIcon, TruckIcon, CreditCardIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';

const services = [
  {
    name: 'Marketplace Integration',
    description: 'Connect seamlessly with major MENAP marketplaces including Amazon, Noon, and Jumia. Our platform handles product listing, inventory sync, and order management automatically.',
    icon: GlobeAltIcon,
  },
  {
    name: 'Localization Services',
    description: 'Full product content translation, currency conversion, and cultural adaptation services to ensure your products resonate with local audiences.',
    icon: ShieldCheckIcon,
  },
  {
    name: 'Logistics & Fulfillment',
    description: 'End-to-end logistics management including warehousing, customs clearance, and last-mile delivery with 1-3 day shipping across MENAP.',
    icon: TruckIcon,
  },
  {
    name: 'Payment Solutions',
    description: 'Integration with local payment methods including Mada, Apple Pay, and cash on delivery to maximize conversion rates.',
    icon: CreditCardIcon,
  },
];

function Services() {
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
        <div className="text-center">
          <h2 className="text-base font-semibold text-[#0049ac] tracking-wide uppercase">Our Services</h2>
          <p className="mt-2 text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl">
            Everything you need to succeed in MENAP
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            Comprehensive solutions to help you expand and thrive in the Middle East, North Africa, and Pakistan markets.
          </p>
        </div>

        <div className="mt-16">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {services.map((service) => (
              <div
                key={service.name}
                className="relative bg-gray-100 p-6 rounded-lg shadow-sm hover:shadow-md transition-all transform hover:scale-105"
              >
                <div className="absolute -top-4 left-6">
                  <div className="rounded-lg bg-[#0049ac] p-3 inline-block">
                    <service.icon className="h-6 w-6 text-white" aria-hidden="true" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="mt-8 text-xl font-semibold text-gray-900">{service.name}</h3>
                  <p className="mt-4 text-gray-600 leading-relaxed">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 rounded-2xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-extrabold text-gray-900">Ready to expand into MENAP?</h3>
            <p className="mt-4 text-lg text-gray-500">
              Get started today and unlock the potential of the $70 billion MENAP e-commerce market.
            </p>
            <div className="mt-8">
              <a
                href="/contact"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full text-white bg-[#0049ac] hover:scale-105 transform transition-all duration-300 font-poppins"
              >
                Schedule a Demo
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;